"use client";

import { c as _c } from "react/compiler-runtime";
import LinkButton from "@/components/ui/Link";
interface Props {
  isLoggedIn: boolean;
  hasActiveSubscription: boolean;
  daysLeft?: number;
}
export function SubscriptionArea(t0) {
  const $ = _c(5);
  const {
    isLoggedIn,
    hasActiveSubscription,
    daysLeft
  } = t0;
  if (hasActiveSubscription) {
    let t1;
    if ($[0] !== daysLeft) {
      t1 = <div className="flex items-center gap-1.5 px-3 py-1.5 h-10 rounded-lg bg-green-500/10 border border-green-500/30"><span className="text-green-400 text-xs font-semibold whitespace-nowrap">اشتراک فعال ({daysLeft})</span></div>;
      $[0] = daysLeft;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  const t1 = isLoggedIn ? "/account/plans" : "/login?returnTo=%2Faccount%2Fplans";
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="text-sm">خرید</span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <LinkButton href={t1} className="flex items-center h-10" variant="primary" size="lg" title={"\u062E\u0631\u06CC\u062F \u0627\u0634\u062A\u0631\u0627\u06A9"}>{t2}</LinkButton>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}